import './Button.scss';
import React from 'react';
import { Button as PrButton } from 'primereact/button'
import classNames from 'classnames'

function Button({className, ...restProps}) {

  return (
    <PrButton className={classNames('Button', className)} {...restProps} >
        {restProps.children}
    </PrButton>
  );
}

export default Button;
